import React from 'react'
import ReportBenefitPage from "./ReportBenefitPage"

function ReportBenefitContainer() {
    return (
        <div className="ReportByDayContainer">
            <ReportBenefitPage/>
        </div>
    )
}

export default ReportBenefitContainer
